<template>
  <pui-dialog ref="dialog" class="pui-file-upload-error" transition="slide-up">
    <template #title>
      <span class="upload-errored-files-dialog-title">
        <i18n path="common.upload.error_dialog.title.main" class="errored-files-sub-title">
          <template #primary>
            {{ $t('common.upload.error_dialog.title.primary') }}
          </template>
          <template #secondary>
            {{ $t('common.upload.error_dialog.title.secondary', { count: errorFileNames.length }) }}
          </template>
        </i18n>
      </span>
    </template>

    <template #default>
      <pui-flex class="upload-errored-files-dialog-content" direction="column">
        <pui-flex justifyContent="center">
          <pui-flex class="errored-files-list" direction="column">
            <!-- we can use file name index since they won't change positions -->
            <div
              v-for="(errorFileName, index) in errorFileNames"
              :key="index"
              class="errored-file-name"
            >
              {{ errorFileName }}
            </div>
          </pui-flex>
        </pui-flex>

        <pui-flex justifyContent="end">
          <pui-button @click.stop="closeDialog">
            {{ $t('common.upload.error_dialog.buttons.close') }}
          </pui-button>
        </pui-flex>
      </pui-flex>
    </template>
  </pui-dialog>
</template>

<script>
export default {
  name: 'pui-file-upload-error',
  props: {
    /**
     * The names of the files that did not upload
     *
     * @type {string[]}
     * @default []
     */
    errorFileNames: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     * Closes the dialog and emits the 'close' event
     *
     * @returns {void}
     */
    closeDialog() {
      this.$refs.dialog.close();
      this.$emit('close');
    },
  },
  /**
   * Mounted hook
   * Opens the dialog
   *
   * @returns {void}
   */
  mounted() {
    this.$refs.dialog.open();
  },
};
</script>
